<template>
  <div>
    <data-table ref="dataTable" :option="option" class="table">
      <template slot="headAction">
        <a-button
          v-if="showJuKeUpload"
          type="primary"
          style="margin-top: 4px"
          @click="openJuYouJuKeModal"
        >
          聚客优客数据上传
        </a-button>
      </template>
    </data-table>
    <JuYouJuKeModal ref="juYouJuKeModal" />
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import JuYouJuKeModal from "./JuYouJuKeModal.vue";

export default {
  name: "InterfaceDocking",
  components: {
    DataTable,
    JuYouJuKeModal
  },
  data() {
    return {
      option: {},
      showJuKeUpload: false
    };
  },
  created() {
    this.getDefaultItem();
    this.option = {
      headSearch: {
        width: 1000,
        colnum: 4,
        content: [
          {
            label: "开始日期",
            name: "StartDate",
            type: "date",
            colnum: 1
          },
          {
            label: "结束日期",
            name: "EndDate",
            type: "date",
            colnum: 1
          },
          {
            label: "操作",
            name: "Action",
            props: {
              placeholder: "请输入操作"
            },
            pressEnter: () => {
              setTimeout(() => {
                this.$refs.dataTable.headSearch();
              }, 100);
            }
          },
          {
            label: "业务",
            name: "Business",
            props: {
              placeholder: "请输入业务"
            },
            pressEnter: () => {
              setTimeout(() => {
                this.$refs.dataTable.headSearch();
              }, 100);
            }
          }
        ]
      },
      grid: {
        api: "OpenApiLog_QueryPage",
        props: {
          scroll: { x: 1800, y: window.document.body.clientHeight - 280 }
        },
        columns: [
          {
            title: "序号",
            width: 60,
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "动作",
            width: 120,
            dataIndex: "Action"
          },
          {
            title: "业务",
            width: 120,
            dataIndex: "Business"
          },
          {
            title: "操作人",
            width: 120,
            dataIndex: "CreatorUserName"
          },
          {
            title: "请求时间",
            width: 160,
            dataIndex: "RequestTime"
          },
          {
            title: "请求数据",
            width: 200,
            dataIndex: "Json",
            customRender: text => this.renderEllipsis(text)
          },
          {
            title: "返回数据",
            width: 200,
            dataIndex: "Output",
            customRender: text => this.renderEllipsis(text)
          },
          {
            title: "耗时",
            width: 100,
            dataIndex: "TimeSpan"
          },
          {
            title: "异常",
            width: 180,
            dataIndex: "Error",
            customRender: text => this.renderEllipsis(text, 180)
          },
          {
            title: "备用数据",
            width: 180,
            dataIndex: "Backup",
            customRender: text => this.renderEllipsis(text, 180)
          },
          {
            title: "备用数据2",
            width: 180,
            dataIndex: "Backup2",
            customRender: text => this.renderEllipsis(text, 180)
          }
        ]
      }
    };
  },
  methods: {
    getDefaultItem() {
      this.$post("Room_GetDefaultTime", {}).then(res => {
        const item = (res.Data.SystemConstList || []).find(
          el => el.Code === "JuKeYouKeApiParam"
        );
        this.showJuKeUpload = item && item.Value && item.Value.length > 50;
      });
    },
    openJuYouJuKeModal() {
      this.$refs.juYouJuKeModal.open();
    },
    renderEllipsis(text, width = 200) {
      if (!text) {
        return "";
      }
      return (
        <a-tooltip
          overlayClassName="operation-log-tooltip-overlay"
          overlayStyle={{ maxWidth: "400px", minWidth: "400px" }}
        >
          <template slot="title">
            <div class="operation-log-tooltip-content">{text}</div>
          </template>
          <div
            style={`width:${width}px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;`}
          >
            {text}
          </div>
        </a-tooltip>
      );
    }
  }
};
</script>

<style lang="less" scoped>
.table {
  /deep/ .ant-table {
    word-break: break-all;
  }
}
</style>

<style lang="less">
.operation-log-tooltip-overlay {
  .ant-tooltip-inner {
    min-width: 400px;
    max-width: 400px;
  }
}

.operation-log-tooltip-content {
  max-height: 60vh;
  overflow-y: auto;
  word-break: break-all;
  white-space: pre-wrap;
}
</style>
